module.exports = __webpack_public_path__ + "static/media/decon-gray.77d094d2.jpg";